import UserPermissionsEdit from './UserPermissionsEdit.vue'
export { UserPermissionsEdit }
export default UserPermissionsEdit
